// import "@fontsource/noto-sans-jp"
// import "./src/styles/base.css"
// import "./src/styles/blog-contents-style.css"

// export const onRouteUpdate = () => {
//   // 🔥 追加
//   if (typeof window !== "undefined" && window.lenis) {
//     window.lenis.scrollTo(0, { immediate: true })
//   }

//   if (typeof document !== "undefined") {
//     const elements = document.querySelectorAll(".fadeInUp, .fadeIn")

//     const observer = new IntersectionObserver(
//       entries => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add("on")
//           }
//         })
//       },
//       { threshold: 0.1 }
//     )

//     elements.forEach(el => observer.observe(el))

//     return () => {
//       elements.forEach(el => observer.unobserve(el))
//     }
//   }
// }

// export const shouldUpdateScroll = () => false
import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

export const shouldUpdateScroll = () => false

export const onRouteUpdate = () => {
  if (typeof window === "undefined") return

  // 🔥 まず強制トップへ
  if (window.lenis) {
    window.lenis.scrollTo(0, { immediate: true })
  } else {
    window.scrollTo(0, 0)
  }

  const elements = document.querySelectorAll(".fadeInUp, .fadeIn")

  const fadeCheck = () => {
    elements.forEach(el => {
      const rect = el.getBoundingClientRect()
      if (rect.top < window.innerHeight * 0.9) {
        el.classList.add("on")
      }
    })
  }

  // 初回実行
  setTimeout(fadeCheck, 50)

  // Lenisスクロールに同期
  if (window.lenis) {
    window.lenis.on("scroll", fadeCheck)
  } else {
    window.addEventListener("scroll", fadeCheck)
  }
}
